<!--Modal-->
<div class="modal" id="modal" role="dialog" aria-modal="true"
  [ngClass]="{'active': active, 'modal--bottom': isModalBottom,'modal--cancel-bar': isModalCancelBar}">
  @if (!template) {
    <ng-content></ng-content>
  }
  @if (template) {
    <ng-container [ngTemplateOutlet]="template">
    </ng-container>
  }
</div>

<div class="modal-bg js-close-modal" id="modal-backdrop" [ngClass]="{'active': active}"></div>